import { User } from '../types/auth';

/**
 * Checks if the current user has explicit PRO activation for Ebook.
 * Following user requirement: Both Teachers and Students must be activated by Admin
 * to see the PRO icon and use PRO features.
 */
export const isProUser = (user: User | null): boolean => {
  if (!user) return false;
  
  // Strictly check for explicit Ebook PRO permission
  return !!user.permissions?.pro;
};
